function hasGetDisplayMedia(nav) {
  if (!nav) return false;
  const md = nav.mediaDevices;
  if (md && typeof md.getDisplayMedia === 'function') return true;
  if (typeof nav.getDisplayMedia === 'function') return true;
  if (typeof MediaDevices !== 'undefined' && MediaDevices.prototype && typeof MediaDevices.prototype.getDisplayMedia === 'function') {
    return true;
  }
  return false;
}

export function getSecurityCapabilities() {
  const doc = typeof document !== 'undefined' ? document.documentElement : null;
  const nav = typeof navigator !== 'undefined' ? navigator : null;
  return {
    fullscreenSupported: !!(doc && (doc.requestFullscreen || doc.webkitRequestFullscreen)),
    displayMediaSupported: hasGetDisplayMedia(nav),
    visibilityApiSupported: typeof document !== 'undefined' && typeof document.visibilityState === 'string',
    beforeUnloadSupported: typeof window !== 'undefined' && 'onbeforeunload' in window,
    displaySurfaceDetectionSupported: typeof MediaStreamTrack !== 'undefined',
    indexedDbSupported: typeof indexedDB !== 'undefined'
  };
}

export function missingRequiredCapabilities(policy) {
  const caps = getSecurityCapabilities();
  const missing = [];
  if (policy.requireFullscreen && !caps.fullscreenSupported) missing.push('Fullscreen');
  return { caps, missing };
}
